/* ==========================================================================
   ZERO LIMITS SUPPLEMENTS  //  zl-global.js
   No framework, no dependencies. Defers all heavy work until DOM ready.
   Uses Shopify AJAX Cart API (/cart/add.js, /cart.js, /cart/change.js).
   ========================================================================== */
(function () {
  "use strict";

  var money = window.ZL && window.ZL.moneyFormat ? window.ZL.moneyFormat : "${{amount}}";

  /* ---- money formatter (mirrors a subset of Shopify's currency filter) ---- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var withCommas = parts[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    var amount = withCommas + "." + parts[1];
    return money.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas);
  }

  /* ---- tiny helpers ---- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initCartDrawer();
    initProductForms();
    initProductGallery();
    initVariantPickers();
    initQuantity();
    initReveal();
  });

  /* ---- MOBILE NAV ---- */
  function initMobileNav() {
    var nav = $("[data-mobile-nav]");
    if (!nav) return;
    var open = $("[data-mobile-nav-open]");
    var closers = $all("[data-mobile-nav-close]", nav);
    function toggle(state) { nav.setAttribute("aria-hidden", state ? "false" : "true"); document.body.style.overflow = state ? "hidden" : ""; }
    if (open) open.addEventListener("click", function () { toggle(true); });
    closers.forEach(function (c) { c.addEventListener("click", function () { toggle(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") toggle(false); });
  }

  /* ---- CART DRAWER ---- */
  function initCartDrawer() {
    var drawer = $("[data-cart-drawer]");
    if (!drawer) return;
    var openers = $all("[data-cart-open]");
    var closers = $all("[data-cart-close]", drawer);
    function open() { drawer.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; }
    function close() { drawer.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; }
    openers.forEach(function (o) {
      o.addEventListener("click", function (e) {
        // allow the cart link to still work if JS-disabled; here we intercept
        if (o.dataset.cartOpen !== "force-link") { e.preventDefault(); open(); }
      });
    });
    closers.forEach(function (c) { c.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    window.ZLCart = { open: open, close: close, refresh: refreshCart };
  }

  /* ---- ADD TO CART (all product forms) ---- */
  function initProductForms() {
    $all("form[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = $("[data-add-to-cart]", form);
        var original = btn ? btn.innerHTML : "";
        if (btn) { btn.setAttribute("disabled", "true"); btn.innerHTML = "Loading kit..."; }
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(serialize(form))
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) { throw new Error(res.data && res.data.description ? res.data.description : "Could not add to cart"); }
            return refreshCart();
          })
          .then(function () { if (window.ZLCart) window.ZLCart.open(); })
          .catch(function (err) {
            var note = $("[data-form-error]", form);
            if (note) note.textContent = err.message;
          })
          .finally(function () { if (btn) { btn.removeAttribute("disabled"); btn.innerHTML = original; } });
      });
    });
  }

  function serialize(form) {
    // FormData includes controls linked via the HTML5 `form=` attribute
    // (the quantity selector is rendered as a sibling block, not a descendant).
    var data = new FormData(form);
    return { id: data.get("id"), quantity: parseInt(data.get("quantity"), 10) || 1 };
  }

  /* ---- REFRESH CART STATE (count badge + drawer contents) ---- */
  function refreshCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $all("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "" : "none";
        });
        renderDrawer(cart);
        return cart;
      });
  }

  function renderDrawer(cart) {
    var list = $("[data-cart-items]");
    var totalEl = $("[data-cart-total]");
    var footer = $("[data-cart-foot]");
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<div class="zl-empty">Your loadout is empty.<br>Gear up.</div>';
      if (footer) footer.style.display = "none";
      return;
    }
    if (footer) footer.style.display = "";
    list.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, "_120x$1$2") : "";
      var opts = item.options_with_values ? item.options_with_values.map(function (o) { return o.value; }).filter(function (v) { return v && v !== "Default Title"; }).join(" / ") : "";
      return '' +
        '<div class="zl-line-item" data-line-key="' + item.key + '">' +
          '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
          '<div>' +
            '<div class="zl-line-item__title">' + escapeHtml(item.product_title) + '</div>' +
            (opts ? '<div class="zl-line-item__meta">' + escapeHtml(opts) + '</div>' : '') +
            '<div class="zl-line-item__meta">QTY ' + item.quantity + ' // ' + formatMoney(item.final_line_price) + '</div>' +
            '<button class="zl-line-item__remove" data-line-remove="' + item.key + '">Remove</button>' +
          '</div>' +
          '<div class="zl-card__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    }).join("");
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    $all("[data-line-remove]", list).forEach(function (b) {
      b.addEventListener("click", function () {
        changeLine(b.getAttribute("data-line-remove"), 0);
      });
    });
  }

  function changeLine(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCart(); });
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* ---- PRODUCT GALLERY ---- */
  function initProductGallery() {
    var gallery = $("[data-gallery]");
    if (!gallery) return;
    var main = $("[data-gallery-main] img", gallery);
    $all("[data-gallery-thumb]", gallery).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        if (main && full) { main.src = full; main.srcset = ""; }
        $all("[data-gallery-thumb]", gallery).forEach(function (t) { t.setAttribute("aria-current", "false"); });
        thumb.setAttribute("aria-current", "true");
      });
    });
  }

  /* ---- VARIANT PICKERS ---- */
  function initVariantPickers() {
    $all("[data-variant-picker]").forEach(function (picker) {
      // The picker and the buy form are sibling blocks, so look up the form
      // within the shared buy column / section rather than via .closest('form').
      var scope = picker.closest(".zl-pdp__sticky") || picker.closest("section") || document;
      var form = scope.querySelector("form[data-product-form]");
      var idInput = form ? form.querySelector("[name='id']") : null;
      var variants;
      try { variants = JSON.parse(picker.getAttribute("data-variants") || "[]"); } catch (e) { variants = []; }
      var priceEl = scope.querySelector("[data-pdp-price]");
      var addBtn = form ? $("[data-add-to-cart]", form) : null;

      $all("[data-variant-option]", picker).forEach(function (btn) {
        btn.addEventListener("click", function () {
          $all("[data-variant-option]", picker).forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
          btn.setAttribute("aria-pressed", "true");
          var vid = btn.getAttribute("data-variant-id");
          if (idInput) idInput.value = vid;
          var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0];
          if (v && priceEl) priceEl.innerHTML = formatMoney(v.price);
          if (v && addBtn) {
            if (v.available) { addBtn.removeAttribute("disabled"); addBtn.textContent = addBtn.getAttribute("data-add-label") || "Add to cart"; }
            else { addBtn.setAttribute("disabled", "true"); addBtn.textContent = "Out of stock"; }
          }
        });
      });
    });
  }

  /* ---- QUANTITY STEPPERS ---- */
  function initQuantity() {
    $all("[data-qty]").forEach(function (wrap) {
      var input = $("input", wrap);
      $all("[data-qty-step]", wrap).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = parseInt(btn.getAttribute("data-qty-step"), 10);
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
        });
      });
    });
  }

  /* ---- SCROLL REVEAL ---- */
  function initReveal() {
    var els = $all(".zl-reveal");
    if (!els.length || !("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
})();
